<template>
	<div class="page">
		<Tip :tip="tip" />
		<div class="screen_div">
			<el-date-picker class="picker" v-model="form.created_time" type="datetimerange" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" placeholder="选择时间范围" />
			<el-input class="input" v-model="form.good_name" style="width: 250px;" placeholder="商品名称" clearable />
			<el-button plain @click="getSupplierSale(1)" style="margin-left: 10px;">筛选</el-button>
		</div>
		<el-table class="table_div" :data="tableData" :header-cell-style="tabStyle">
			<el-table-column type="selection" width="50" />
			<el-table-column label="排序" type="index" width="80" />
			<el-table-column label="商品">
				<template slot-scope="scope">
					<div class="col">
						<span>名称：{{scope.row.good_name}} </span>
						<span>规格：{{scope.row.spec_data_str}}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="累计销量">
				<template slot-scope="scope">
					<span>{{scope.row.sale}}</span>
				</template>
			</el-table-column>
			<el-table-column label="未结算量">
				<template slot-scope="scope">
					<span>{{scope.row.settlement_undo}}</span>
				</template>
			</el-table-column>
			<el-table-column label="结算中">
				<template slot-scope="scope">
					<span>{{scope.row.settlement_ing}}</span>
				</template>
			</el-table-column>
			<el-table-column label="未结算总额">
				<template slot-scope="scope">
					<span>{{scope.row.settlement_undo_amount}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="180">
				<template slot-scope="scope">
					<el-button class="item_btn" size="mini" type="warning" v-if="is_supplier"
						@click="open('settlementDocListEdit', scope.row.sku_id)">结算</el-button>
					<el-button class="item_btn" size="mini" type="primary"
						@click="open('saleCountDetail', scope.row.sku_id)">明细</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--弹出层-->
		<Popup :name="name" :show="show" :type="sku_id" :arr="arr" @close='close' />

		<div class="foot_div">
			<div>
                <el-button>全选</el-button>
                <el-button type="danger">清空选择</el-button>
                <el-button type="primary">批量处理</el-button>
            </div>

            <el-pagination class="pagination" background layout="prev, pager, next,jumper, ->, total" :total="total"
				@current-change="handleCurrentChange" :currentPage="form.page" :pageSize="form.limit">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import Popup from "../../../components/Popup/Popup.vue"
    import {
		supplier,
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip,
			Popup
		},
		data() {
			return {
				tip: '已经完成状态的订单中，货品的结算情况统计。',
                total: 0,
				tableData: [],
				name: '',
				show: false,
                form: {
                    good_name: '',
                    created_time: [],
                    page: 1,
                    limit: 10,
                },
                arr: [],
                sku_id: 0,
                is_supplier: false,
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333'
				}
			}
		},
        mounted() {
			this.getSupplierSale();
            var loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
            this.is_supplier = loginInfo.supplier_id > 0;
		},
		methods: {
            getSupplierSale(page){
                this.loading = true;
                this.form.page = page || this.form.page;
                supplier(this.form, 2).then(res => {
                    this.loading = false;
					if (res.code == 0) {
						this.total = res.count
						this.tableData = res.data
					}else{
                        return this.$message.error(res.msg);
                    }
				}).catch(err => {})
            },
			handleCurrentChange(page) {
				this.form.page = page; //每次点击分页按钮，当前页发生变化
				this.getSupplierSale();
			},
			open(name, sku_id) {
                this.arr = [sku_id];
                this.sku_id = sku_id;
				this.name = name;
				this.show = true
			},
			close() {
				this.show = false
			}
		}
	}
</script>

<style scoped>
	.screen_div {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: auto;
		margin: 20px 0;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.picker {
		width: 180px;
		margin-right: 13px;
	}

	.select {
		width: 130px;
		margin-right: 13px;
	}

	.el-button--mini {
		margin-right: 10px;
	}

	.item_btn {
		margin: 5px 5px 0 0;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		margin-left: 66px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
        display: flex;
	}
    .pagination {
		display: flex;
		justify-content: right;
		padding: 20px 30px 20px 30px;
        flex: 1;
	}
</style>